export const featureFlags = window.nativeAppFeatureFlags || {};
